import { FunctionComponent, memo } from 'react';
import { colors } from '../../fela-themes';
import { IColorTypes, IFontTypes, TDisplayValues } from '../../themes/types';
import Box, { IProps as IBoxProps } from './Box';
import { FelaCSS } from './flowtypes';

interface IProps extends IBoxProps, IFontTypes {
  lh?: FelaCSS['lineHeight'];
  color?: keyof IColorTypes;
  display?: TDisplayValues;
  textAlign?: FelaCSS['textAlign'];
}

const Text: FunctionComponent<IProps> = ({
  style,
  display,
  textAlign,
  lh,
  fontDefault,
  fontDefaultBold,
  fontDefaultItalic,
  fontDefaultLight,
  fontDefaultSemiBold,
  color,
  ...restProps
}) => {
  // Handle potential type conflicts in style prop
  const { display: styleDisplay, fontWeight, ...safeStyle } = style || {};
  const finalDisplay = display || styleDisplay;

  const textStyles: FelaCSS = {
    display:
      ((Array.isArray(finalDisplay) ? finalDisplay[0] : finalDisplay) as FelaCSS['display']) ||
      'inline',
    whiteSpace: 'pre-wrap',
    overflowWrap: 'break-word',
    msHyphens: 'auto',
    textAlign,
    ...(fontDefault && { fontDefault }),
    ...(fontDefaultBold && { fontDefaultBold }),
    ...(fontDefaultItalic && { fontDefaultItalic }),
    ...(fontDefaultLight && { fontDefaultLight }),
    ...(fontDefaultSemiBold && { fontDefaultSemiBold }),
    ...(lh && { lineHeight: typeof lh === 'number' ? `${lh}px` : lh }),
    ...(color && { color: colors[color] }),
    ...(fontWeight && { fontWeight: fontWeight as FelaCSS['fontWeight'] }),
    ...safeStyle,
  } as FelaCSS;

  return <Box {...restProps} style={textStyles} />;
};

export default memo(Text);
